import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';

const fetchMetrics = withDraft((draft) => {
  draft.readStatus = states.PENDING;
  draft.readErrors = [];
});

const showMetrics = withDraft((draft, action) => {
  Object.assign(draft, action.response);
  draft.readStatus = states.SUCCESS;
  draft.readErrors = [];
});

const showMetricsError = withDraft((draft, action) => {
  draft.readStatus = states.ERROR;
  draft.readErrors = [responseError(action)];
});

export default {
  [actions.FETCH_METRICS]: fetchMetrics,
  [actions.SHOW_METRICS]: showMetrics,
  [actions.SHOW_METRICS_ERROR]: showMetricsError,
};
